export const SET_CONSULTANTS_LOADING = "SET_CONSULTANTS_LOADING";
export const SET_CONSULTANTS_ERROR = "SET_CONSULTANTS_ERROR";

export const FETCH_CONSULTANTS_REQUEST = "FETCH_CONSULTANTS_REQUEST";
export const FETCH_CONSULTANTS_SUCCESS = "FETCH_CONSULTANTS_SUCCESS";
export const FETCH_CONSULTANTS_FAIL = "FETCH_CONSULTANTS_FAIL";

export const CREATE_CONSULTANT_REQUEST = "CREATE_CONSULTANT_REQUEST";
export const CREATE_CONSULTANT_SUCCESS = "CREATE_CONSULTANT_SUCCESS";
export const CREATE_CONSULTANT_FAIL = "CREATE_CONSULTANT_FAIL";

export const UPDATE_CONSULTANT_REQUEST = "UPDATE_CONSULTANT_REQUEST";
export const UPDATE_CONSULTANT_SUCCESS = "UPDATE_CONSULTANT_SUCCESS";
export const UPDATE_CONSULTANT_FAIL = "UPDATE_CONSULTANT_FAIL";

export const DELETE_CONSULTANT_REQUEST = "DELETE_CONSULTANT_REQUEST";
export const DELETE_CONSULTANT_SUCCESS = "DELETE_CONSULTANT_SUCCESS";
export const DELETE_CONSULTANT_FAIL = "DELETE_CONSULTANT_FAIL";

export const setConsultantsLoading = (v) => ({ type: SET_CONSULTANTS_LOADING, payload: v });
export const setConsultantsError = (msg) => ({ type: SET_CONSULTANTS_ERROR, payload: msg });

export const fetchConsultantsRequest = () => ({ type: FETCH_CONSULTANTS_REQUEST });
export const fetchConsultantsSuccess = (data) => ({ type: FETCH_CONSULTANTS_SUCCESS, payload: data });
export const fetchConsultantsFail = (err) => ({ type: FETCH_CONSULTANTS_FAIL, payload: err });

export const createConsultantRequest = (payload) => ({ type: CREATE_CONSULTANT_REQUEST, payload });
export const createConsultantSuccess = (data) => ({ type: CREATE_CONSULTANT_SUCCESS, payload: data });
export const createConsultantFail = (err) => ({ type: CREATE_CONSULTANT_FAIL, payload: err });

export const updateConsultantRequest = (id, payload) => ({ type: UPDATE_CONSULTANT_REQUEST, payload: { id, payload } });
export const updateConsultantSuccess = (data) => ({ type: UPDATE_CONSULTANT_SUCCESS, payload: data });
export const updateConsultantFail = (err) => ({ type: UPDATE_CONSULTANT_FAIL, payload: err });

export const deleteConsultantRequest = (id) => ({ type: DELETE_CONSULTANT_REQUEST, payload: { id } });
export const deleteConsultantSuccess = (id) => ({ type: DELETE_CONSULTANT_SUCCESS, payload: id });
export const deleteConsultantFail = (err) => ({ type: DELETE_CONSULTANT_FAIL, payload: err });
